import { computed } from "vue"
import { useStore } from "vuex"

export function useCart() {
  const store = useStore()
  const cart = computed(() => store.state.cart?.cart)
  const items = computed(() => {
    const c = store.state.cart?.cart
    return c?.cart_items ?? c?.cart?.cart_items ?? []
  })
  const removeCartItem = (id) => store.dispatch('cart/removeItem', id)
  const updateCartItemQuantity = async (payload) => {
    await store.dispatch('cart/updateCartItemOption', payload)
    try {
      await store.dispatch('checkout/getCheckout')
      const currentShipping = store.state.checkout?.checkout?.cart?.shipping
      if (currentShipping) {
        await store.dispatch('checkout/setShippingMethod', currentShipping)
      }
    } catch (err) {
      throw err
    }
  }

  const deleteCartItem = async (item) => {
    try {
      if (item.deal_type) {
        await store.dispatch('cart/removeBeautyDeal', item.id)
      } else if (item.wishlist_name && item.datafield?.wishlist_id) {
        await store.dispatch('cart/removeWishlistProduct', {
          productId: item.product.id,
          wishlistId: item.datafield.wishlist_id,
        })
      } else {
        await store.dispatch('cart/removeProduct', item.product.id)
      }
      await store.dispatch('cart/getCart')
      const currentCart = store.state.cart?.cart
      if (currentCart) {
        await store.dispatch('product/updateSelectedSamplesFromCart', currentCart)
      }
    } catch (err) {
      throw err
    } finally {
      await store.dispatch('vouchers/getCartVouchers')
    }
  }

  const removeAllItems = () => store.dispatch('cart/removeAllItems').then(() => {
    store.dispatch('vouchers/getCartVouchers')
  })

  return {
    cart,
    items,
    removeCartItem,
    updateCartItemQuantity,
    deleteCartItem,
    removeAllItems,
  }
}
